export default function logToCartAttribute(key, data) {
  fetch(`${window.routes.cart_url}.js`, {
    headers: {
      "Content-Type": "application/json",
    },
  })
    .then(res => res.json())
    .then(cart => {
      const value = JSON.parse(cart.attributes[key] || '[]');

      value.push(data);

      const body = {
        attributes: {
          [key]: JSON.stringify(value),
        },
      };

      fetch(`${window.routes.cart_update_url}.js`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      });
    });
}
